import { useEffect, useState } from "react";
import { Grid, Item } from "@mui/material";
import WwRow from "./WwRow";
import WwText from "./WwText";
import WwSVG from "./WwSVG";
import WwImage from "./WwImage";
import WwVideo from "./WwVideo";
import WwILTButton from "./WwILTButton";

import WwSmallChit from "./WwSmallChit";
import WwAvtar from "./WwAvtar";
import WwArticle from "./WwArticle";
import WwBigHeading from "./WwBigHeading";
import WwBigSubHeading from "./WwBigSubHeading";
import WwHeading from "./WwHeading";
import WwIconImage from "./WwIconImage";
import WwInstruction from "./WwInstruction";
import WwList from "./WwList";
import WwListBg from "./WwListBg";
import WwListHeading from "./WwListHeading";
import WwListNormal from "./WwListNormal";
import WwMaxHeight from "./WwMaxHeight";
import WwSmallChit1 from "./WwSmallChit1";
import WwSmallChit2 from "./WwSmallChit2";
import WwSubheading from "./WwSubheading";
import WwChat from "./WwChat";

const WwCol = (props) => {
  let [classnames, setClassnames] = useState("");
  let [alignClass, setAlignClass] = useState("");

  useEffect(() => {
    console.log("GGGGGG", props.data.style.decoration_classes);
    let allClasses = "";
    if (
      props.data.style.decoration_classes !== null &&
      props.data.style.decoration_classes !== undefined
    ) {
      allClasses = props.data.style.decoration_classes.join(" ");
    }

    //setClassnames(classnames + "q-pa-xs");

    if (
      props.data.style.align !== null &&
      props.data.style.align !== undefined
    ) {
      setAlignClass(props.data.style.align);
    } else {
      setAlignClass("");
    }

    if (
      props.data.items &&
      props.data.items.length > 0 &&
      props.data.items[0]["type"] == "text"
    ) {
      allClasses = `${allClasses} ${props.data.items[0].class}`;
      if (
        props.data.items[0].style.decoration_classes &&
        Array.isArray(props.data.items[0].style.decoration_classes)
      ) {
        allClasses = `${allClasses} ${props.data.items[0].style.decoration_classes?.join(
          " "
        )}`;
      }
    }

    setClassnames(allClasses);
  }, [props.data]);

  useEffect(() => {
    console.log("classnames", classnames);
  }, [classnames]);

  const renderComponent = (componentProps, parentData) => {
    //console.log("SSSSSS", componentProps);
    switch (componentProps.type) {
      case "row":
        return <WwRow data={componentProps} initHide={props.initHide}></WwRow>;
      case "svg":
        return (
          <WwSVG
            data={componentProps}
            initHide={props.initHide}
            parentData={parentData}
          ></WwSVG>
        );
      case "text":
        return selectTextComponent(componentProps);
      case "image":
        return selectImgComponent(componentProps);
      case "video":
        return (
          <WwVideo data={componentProps} initHide={props.initHide}></WwVideo>
        );
      case "button":
        if (props.component == "wwroundbtn") {
          return (
            <WwILTButton
              data={componentProps}
              round={true}
              initHide={props.initHide}
            ></WwILTButton>
          );
        } else {
          return (
            <WwILTButton
              data={componentProps}
              flat={true}
              initHide={props.initHide}
            ></WwILTButton>
          );
        }
      case "chat":
        return (
          <WwChat data={componentProps} initHide={props.initHide}></WwChat>
        );
    }
  };

  const selectTextComponent = (componentProps) => {
    switch (props.component) {
      case "wwsmallchit":
        return (
          <WwSmallChit
            data={componentProps}
            initHide={props.initHide}
          ></WwSmallChit>
        );
      case "wwavtar":
        return (
          <WwAvtar
            data={componentProps}
            avatarText={true}
            initHide={props.initHide}
          ></WwAvtar>
        );
      case "wwinstruction":
        return (
          <WwInstruction
            data={componentProps}
            initHide={props.initHide}
          ></WwInstruction>
        );
      case "wwunorderedlist":
      case "wwlist":
        return (
          <WwList data={componentProps} initHide={props.initHide}></WwList>
        );
      case "wwlistnormal":
        return (
          <WwListNormal
            data={componentProps}
            initHide={props.initHide}
          ></WwListNormal>
        );
      case "wwlistbg":
        return (
          <WwListBg data={componentProps} initHide={props.initHide}></WwListBg>
        );
      case "wwheading":
        return (
          <WwHeading
            data={componentProps}
            initHide={props.initHide}
          ></WwHeading>
        );
      case "wwsubheading":
        return (
          <WwSubheading
            data={componentProps}
            initHide={props.initHide}
          ></WwSubheading>
        );
      case "wwlistheading":
        return (
          <WwListHeading
            data={componentProps}
            initHide={props.initHide}
          ></WwListHeading>
        );
      case "wwbigheading":
        return (
          <WwBigHeading
            data={componentProps}
            initHide={props.initHide}
          ></WwBigHeading>
        );
      case "wwbigsubheading":
        return (
          <WwBigSubHeading
            data={componentProps}
            initHide={props.initHide}
          ></WwBigSubHeading>
        );
      case "wwmaxheight":
        return (
          <WwMaxHeight
            data={componentProps}
            initHide={props.initHide}
          ></WwMaxHeight>
        );
      case "wwsmallchit1":
        return (
          <WwSmallChit1
            data={componentProps}
            initHide={props.initHide}
          ></WwSmallChit1>
        );
      case "wwsmallchit2":
        return (
          <WwSmallChit2
            data={componentProps}
            initHide={props.initHide}
          ></WwSmallChit2>
        );
      case "wwarticle":
        return (
          <WwArticle
            data={componentProps}
            avatarText={true}
            initHide={props.initHide}
          ></WwArticle>
        );
      default:
        return (
          <WwText data={componentProps} initHide={props.initHide}></WwText>
        );
    }
  };

  const selectImgComponent = (componentProps) => {
    switch (props.component) {
      case "wwimage":
        return (
          <WwImage data={componentProps} initHide={props.initHide}></WwImage>
        );
      case "wwavtar":
        return (
          <WwAvtar
            data={componentProps}
            avatarImg={true}
            initHide={props.initHide}
          ></WwAvtar>
        );
      default:
        return (
          <WwImage data={componentProps} initHide={props.initHide}></WwImage>
        );
    }
  };

  return (
    <>
      {props.data && (
        <Grid
          container
          id={props.data.myId.self}
          sx={{
            marginLeft: "0px",
            marginTop: "0px",
            display:
              props.initHide &&
              props.initHide.indexOf(props.data.myId.self) > -1
                ? "none"
                : "flex",
            alignItems: "flex-start",
          }}
          className={classnames}
        >
          {props.data.items &&
            props.data.items.map((innerDiv, index) => {
              return <>{renderComponent(innerDiv, props.data)}</>;
            })}
        </Grid>
      )}
    </>
  );
};

export default WwCol;
